import React from "react";

type RadioOption = {
    label: string;
    value: string;
}
interface InputFieldProps {
    label: string,
    type: string,
    name: string,
    placeholder?: string,
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
    required: boolean,
    autoFocus?: boolean,
    className: string,
    options?: RadioOption[],
    value: any
}

const InputField: React.FC<InputFieldProps> = ({
                                                   label, type, name,
                                                   placeholder, onChange, required,
                                                   autoFocus = false, className, options,
                                                   value
                                               }) => {
    return (
        <div className={`input-field${type === 'radio' ? ' radio-group' : ''}`}>
            {label && (
                <label htmlFor={name} className="form-label">
                    {label}
                </label>
            )}
            {type === 'radio' ? (
                <div className="radio-options-wrapper">
                  {options!.map((option, index) => (
                    <div key={index} className="radio-option">
                        <input
                            type="radio"
                            name={name}
                            value={option.value}
                            checked={value === option.value}
                            onChange={onChange}
                            required={required}
                            className={className}
                        />
                        <label htmlFor={`${name}-${option.value}`}>{option.label}</label>
                    </div>
                  ))}
                </div>
            ) : (
                <input
                    type={type}
                    name={name}
                    placeholder={placeholder}
                    onChange={onChange}
                    required={required}
                    autoFocus={autoFocus}
                    className={className}
                    value={value}
                />
            )}
        </div>
    )

}

export default InputField;